import { render, staticRenderFns } from "./TopicIap.vue?vue&type=template&id=a0f61864"
import script from "./TopicIap.vue?vue&type=script&lang=js"
export * from "./TopicIap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports